import React, { useEffect, useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form, Radio } from 'antd';
const QuestionMasterProvider = (props) => {
  const api = new API();
  const [formAdd] = Form.useForm();
  const [formEditQM] = Form.useForm();
  const [formAddtionalQM] = Form.useForm();
  const [qmCategoryLoader, setQmCategoryLoader] = useState(false);
  const [qmBankLoader, setQmBankLoader] = useState(false);
  const [qmCategoryList, setQmCategoryList] = useState([]);
  const [qmBankList, setQmBankList] = useState([]);
  const [qmTableFilter, setQmTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20
  })
  const [qmBankTableFilter, setBankQmTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  })
  const [addTopicPopup, setAddTopicPopup] = useState(false);
  const [qmSubCategoryList, setQmSubCategoryList] = useState([]);
  const [qmSubjectList, setQmSubjectList] = useState([]);
  const [qmMonthList, setQmMonthList] = useState([]);
  const [qmMonthLoader, setQmMonthLoader] = useState(false);
  const [qmTopicList, setQmTopicList] = useState([]);
  const [qmSubCategoryLoader, setQmSubCategoryLoader] = useState(false);
  const [qmSubjectLoader, setQmSubjectLoader] = useState(false);
  const [qmTopicLoader, setQmTopicLoader] = useState(false);
  const [qmQuestionList, setQmQuestionList] = useState([]);
  const [qmQuestionLoader, setQmQuestionLoader] = useState([]);
  const [qmListView, setQmListView] = useState([]);
  const [newSubjectValue, setNewSubjectValue] = useState("");
  const [newTopicValue, setNewTopicValue] = useState("");
  const [viewScreenQM, setViewScreenQM] = useState({
    add: false,
    edit: false,
    view: false,
    list: true,
    editsnap: false
  });
  const [quesLoadingQM, setQuesLoadingQM] = useState({
    list: false,
    singleview: false,
    add:false,
    edit:false,
    delete:false,
    row:false,
    uploadexcel:false,
    uploadword:false
  });
  const [modalQM, setModalQM] = useState({
    excelupload: false,
    wordupload: false
  });
  const [getQestionBankQM,setGetQestionBankQM] = useState({});
  const [singleQuestionQM, setSingleQuestionQM] = useState({});
  const [singleIdQM, setSingleIdQM] = useState("");
  const [excelFileQM, setExcelFileQM] = useState(null);
  const [wordFileQM, setWordFileQM] = useState(null);
  const [rowRefreshQM, setRowRefreshQM] = useState(false);
  const [filterDataQM,setFilterDataQM] = useState([]);
  const [filterLoaderQM,setFilterLoaderQM] = useState(false);
  const [deleteQbankLoader, setDeleteQbankLoader] = useState(false);

  const deleteQbank = async (id,cid) => {
    setDeleteQbankLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.remove("questionbanknew/deleteqbank", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchQMBankList(cid);
          setDeleteQbankLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setDeleteQbankLoader(false);
        }
      })
  }
  const fetchQMCategoryList = async () => {
    setQmCategoryLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('questionbanknew/categorylist', { ...qmTableFilter }, (err, res) => {
        if (res) {
          setQmCategoryList(res?.data?.data);
        } else {
          setQmCategoryList([]);
        }
        setQmCategoryLoader(false);
      })
  };

  const fetchQMBankList = async (cid) => {
    if (!cid) {
      setQmBankList([]);
      return;
    }
    setQmBankLoader(true);
    const filter = { ...qmBankTableFilter,subject_id: qmBankTableFilter?.subject_id?.filter((item) => item !== "subject").join("|"),
    topic_id: qmBankTableFilter?.topic_id?.filter((item) => item !== "topic").join("|"),
    subcategory_id: qmBankTableFilter?.subcategory_id?.filter((item) => item !== "subcategory").join("|") };
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('questionbanknew/qmtablelist', { ...filter, category_id: cid }, (err, res) => {
        if (res) {
          setQmBankList(res?.data?.data);
        } else {
          setQmBankList([]);
        }
        setQmBankLoader(false);
      })
  };

  const fetchQMSubCategoryList = async (cid) => {
    if (!cid) {
      setQmSubCategoryList([]);
      return;
    }
    setQmSubCategoryLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('questionbanknew/qmsubcategorylist', { category_id: cid }, (err, res) => {
        if (res) {
          setQmSubCategoryList(res?.data?.data);
        } else {
          setQmSubCategoryList([]);
        }
        setQmSubCategoryLoader(false);
      })
  };
  const fetchQMSubjectList = async (cid) => {
    if (!cid) {
      setQmSubjectList([]);
      return;
    }
    formAdd.setFieldsValue({
      subject_id: null,
      topic_id: null
    });
    
    setQmSubjectLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('questionbanknew/qmsubjectlist', { subcategory_id: cid }, (err, res) => {
        if (res) {
          setQmSubjectList(res?.data?.data);
        } else {
          setQmSubjectList([]);
        }
        setQmSubjectLoader(false);
      })
  }
  const fetchQMMOnthList = async (cid) => {
    if (!cid) {
      setQmMonthList([]);
      return;
    }
    setQmMonthLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('questionbanknew/qmmonthlist', { subcategory_id: cid }, (err, res) => {
        if (res) {
          setQmMonthList(res?.data?.data);
        } else {
          setQmMonthList([]);
        }
        setQmMonthLoader(false);
      })
  }
  const fetchQMTopicList = async (cid) => {
    if (!cid) {
      setQmTopicList([]);
      return;
    }
    formAdd.setFieldsValue({
      topic_id: null
    });
    setQmTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('questionbanknew/qmtopiclist', { subject_id: cid }, (err, res) => {
        if (res) {
          setQmTopicList(res?.data?.data);
        } else {
          setQmTopicList([]);
        }
        setQmTopicLoader(false);
      })
  }

  const addQmBank = async (data, cid) => {
    localStorage.getItem("rxdx_admin_login") &&
      await api.create('questionbanknew', { ...data, category_id: cid }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchQMBankList(cid);
          setAddTopicPopup(false);
          formAdd.resetFields();
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      })
  }
  const scrollToTopView = (index) => {
    document.getElementById(`question_order_${index}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }
  const fetchQMQuestionList = async (qid) => {
    setQuesLoadingQM({
      ...quesLoadingQM,
      list: true,
    })
    await api.getAll(
      "questionbanknew/questionlist",
      { qid: qid },
      (err, res) => {

        if (res?.data?.status === 200) {
          const sortedQuestionList = res?.data?.data?.map((q, i) => ({
            key: q?.question_order,
            _id: q?._id,
            name: <div className='d_f g_5'>{q?.question_order}<div dangerouslySetInnerHTML={{ __html:q?.question_name }} onClick={() => getQMSinglrQuestion(q?._id, q?.question_order)} style={{ cursor: "pointer" }}></div></div>,
          })).sort((a, b) => a.key - b.key);
          setQmQuestionList(sortedQuestionList);
          setQmListView(res?.data?.data?.map((q, i) => ({
            key: q?.question_order,
            _id: q?._id,
            label: <div className='d_f g_5'>{q?.question_order}<div dangerouslySetInnerHTML={{ __html:q?.question_name }}></div></div>,
            children: <div>
              <p className="m_b_10">Answer</p>
              <div className="col_1 g_10">
                {
                  q?.question_options?.map((o, i) => (
                    <div key={i}>
                      <Radio checked={o?.is_correct}><div dangerouslySetInnerHTML={{ __html: o?.option }} /></Radio>
                    </div>
                  ))
                }
              </div>
            </div>,
          })).sort((a, b) => a.key - b.key));
        } else {
          setQmQuestionList([]);
        }
        setQuesLoadingQM({
          ...quesLoadingQM,
          list: false,
        })
      }
    )
  }
  const getQMSinglrQuestion = async (id, order) => {
    if (viewScreenQM.editsnap === false) {
      scrollToTopView(order);
      return;
    }
    setViewScreenQM({
      ...viewScreenQM,
      add: false,
      edit: false,
      view: true
    });
    setQuesLoadingQM({
      ...quesLoadingQM,
      singleview: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle(
        'questionbanknew/single/question',
        id,
        (err, res) => {

          if (res?.data?.status === 200) {
            setSingleQuestionQM(res?.data?.data);
            setSingleIdQM(res?.data?.data?._id);
            formEditQM.setFieldsValue(res?.data?.data);
           }

          setQuesLoadingQM({
            ...quesLoadingQM,
            singleview: false
          })
        }
      ))
  }
  function dangerouslySetInnerHTMLToText(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
  const addQuestionQM = async (data, qid, reSet) => {
    setQuesLoadingQM((prev) => ({
      ...prev,
      add: true,
    }))
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if (check_correct.length < 1) {
      Widget.showMessage("error", "Please select correct option");
      setQuesLoadingQM((prev) => ({
        ...prev,
        add: false,
      }))
      return;
    }
    if (data?.question_type === "single") {
      if (check_correct.length > 1) {
        Widget.showMessage("error", "Please select single correct option");
        setQuesLoadingQM((prev) => ({
          ...prev,
          add: false,
        }))
        return;
      }
    }

    const form_data = new FormData();

    form_data.append("question_name", data.question_name);
    form_data.append("questionbank_id", qid);
    form_data.append("question_type", data.question_type);
    form_data.append("explanation", data.explanation);
    form_data.append("reference", data.reference);
    form_data.append("iframe_url", data.iframe_url);
    data.question_options.forEach((item, i) => {
      form_data.append(`question_options[${i}][option]`, item.option);
      form_data.append(`question_options[${i}][is_correct]`, Boolean(item.is_correct));
    });

    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("questionbanknew/addquestion", form_data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchQMQuestionList(qid)
          reSet();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setQuesLoadingQM((prev) => ({
          ...prev,
          add: false,
        }))
      }));
  }

  const rowUpdateQM = async (newData=[],qid) => {
    setQuesLoadingQM((prev) => ({
      ...prev,
      row: true,
    }))
    const updateData = [];
    newData?.map((d,i)=>{
      updateData.push({
        _id: d?._id,
        question_order: i+1
      })
    })
    localStorage.getItem("rxdx_admin_login") === "true" && 
    await api.create("questionbanknew/questionlist/rowupdate", {row:updateData}, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQMQuestionList(qid)
      }
      setQuesLoadingQM((prev) => ({
        ...prev,
        row: false,
      }))
    });
  }


  const updateQuestionQM = async (data, id,qid, reSetEdit) => {
    setQuesLoadingQM((prev) => ({
      ...prev,
      edit: true,
    }))
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if(check_correct.length < 1){
      Widget.showMessage("error", "Please select correct option");
      setQuesLoadingQM((prev) => ({
        ...prev,
        edit: false,
      }))
      return;
    }
    if(data?.question_type==="single") {
      if(check_correct.length > 1){
        Widget.showMessage("error", "Please select single correct option");
        setQuesLoadingQM((prev) => ({
          ...prev,
          edit: false,
        }))
        return;
      }
    }
    

    const form_data = new FormData();

    form_data.append("question_name", data.question_name);
    form_data.append("question_type", data.question_type);
    form_data.append("explanation", data.explanation);
    form_data.append("reference", data.reference);
    form_data.append("iframe_url", data.iframe_url);
    data.question_options.forEach((item, i) => {
      form_data.append(`question_options[${i}][option]`, item.option);
      form_data.append(`question_options[${i}][is_correct]`, Boolean(item.is_correct));
    });
    localStorage.getItem("rxdx_admin_login") === "true" && 
    await api.update("questionbanknew/updatequestion",id, form_data, (err, res) => {
      if(res) {
        formEditQM.resetFields();
        fetchQMQuestionList(qid)
        Widget.showMessage("success", res?.data?.message);
        reSetEdit();
      }
      setQuesLoadingQM((prev) => ({
        ...prev,
        edit: false,
      }))
    })
  }

  const questionDeleteQM = async (id,qid,reSetEdit) => {
    setQuesLoadingQM((prev) => ({
      ...prev,
      delete: true,
    }))
    localStorage.getItem("rxdx_admin_login") === "true" &&
    await api.remove("questionbanknew",id, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQMQuestionList(qid)
        reSetEdit();
      }
      setViewScreenQM({
        ...viewScreenQM,
        view: false,
        list: true,
      })
      formEditQM.resetFields();
      setQuesLoadingQM((prev) => ({
        ...prev,
        delete: false,
      }))

    });
  }

  const bulkUploadExcelQM = async (qid) => {
    setQuesLoadingQM((prev) => ({
      ...prev,
      uploadexcel: true,
    }))
    if(!excelFileQM) {
      Widget.showMessage("error", "Please select excel file");
      setQuesLoadingQM((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    if(!qid) {
      Widget.showMessage("error", "Please select question bank");
      setQuesLoadingQM((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    const formData = new FormData();
    formData.append("file", excelFileQM);
    formData.append("questionbank_id", qid);
    await api.create("questionbanknew/bulkupload", formData, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQMQuestionList(qid)
        setExcelFileQM(null)
        document.getElementById("excelFile").value = "";
        setModalQM({ ...modalQM, excelupload: false })
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setQuesLoadingQM((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
    })
  }

  const bulkUploadWordQM = async (qid) => {
    setQuesLoadingQM((prev) => ({
      ...prev,
      uploadword: true,
    }))
    if(!wordFileQM) {
      Widget.showMessage("error", "Please select word file");
      setQuesLoadingQM((prev) => ({
        ...prev,
        uploadword: false,
      }))
      return;
    }
    if(!qid) {
      Widget.showMessage("error", "Please select question bank");
      setQuesLoadingQM((prev) => ({
        ...prev,
        uploadword: false,
      }))
      return;
    }
    const formData = new FormData();
    formData.append("file", wordFileQM);
    formData.append("questionbank_id", qid);
    await api.create("wordupload/bulkuploadwordnew", formData, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQMQuestionList(qid)
        setWordFileQM(null)
        document.getElementById("excelFile1").value = "";
        setModalQM({ ...modalQM, wordupload: false })
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setQuesLoadingQM((prev) => ({
        ...prev,
        uploadword: false,
      }))
    })
  }

  const fetchSingleQuestionBankQM = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getSingle(
        `questionbanknew/single`,
        id,
        (err, res) => {
          if (res?.data?.status === 200) {
             setGetQestionBankQM(res?.data?.data);
            formAddtionalQM.setFieldsValue(res?.data?.data)
          } else {
            setGetQestionBankQM({});
          }
        }
      );
  }

  const fetchFilterDropdownQM = async (cid) => {
    if(!cid) return;
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setFilterLoaderQM(true);
      await api.getAll("questionbanknew/filterdropdown",{category_id:cid}, (err, res) => {
        if (res?.data?.status === 200) {
          setFilterDataQM(res?.data?.data);
        } else {
          setFilterDataQM([]);
        }
        setFilterLoaderQM(false);
      })
  }

  return (
    <Context.Provider
      value={{
        ...props,
        qmCategoryLoader,
        setQmCategoryLoader,
        qmCategoryList,
        setQmCategoryList,
        fetchQMCategoryList,
        qmTableFilter,
        setQmTableFilter,
        qmBankLoader,
        setQmBankLoader,
        qmBankList,
        setQmBankList,
        fetchQMBankList,
        qmBankTableFilter,
        setBankQmTableFilter,
        addTopicPopup,
        setAddTopicPopup,
        qmSubCategoryList, setQmSubCategoryList,
        qmSubjectList, setQmSubjectList, qmTopicList, setQmTopicList, qmSubCategoryLoader, qmSubjectLoader, setQmSubjectLoader, setQmSubCategoryLoader, qmTopicLoader, setQmTopicLoader,
        fetchQMSubCategoryList,
        fetchQMSubjectList,
        fetchQMTopicList,
        formAdd,
        addQmBank,
        qmQuestionList,
        setQmQuestionList,
        qmQuestionLoader,
        setQmQuestionLoader,
        qmListView,
        setQmListView,
        fetchQMQuestionList,
        getQMSinglrQuestion,
        addQuestionQM,
        modalQM, 
        setModalQM,
        rowUpdateQM,
        bulkUploadExcelQM,
        questionDeleteQM,
        updateQuestionQM,
        singleQuestionQM, 
        setSingleQuestionQM,
        quesLoadingQM, setQuesLoadingQM,
        excelFileQM, setExcelFileQM,
        singleIdQM, setSingleIdQM,
        viewScreenQM, setViewScreenQM,
        formEditQM,
        formAddtionalQM,
        getQestionBankQM,
        setGetQestionBankQM,
        fetchSingleQuestionBankQM,
        rowRefreshQM, setRowRefreshQM,
        newSubjectValue, setNewSubjectValue,
        newTopicValue, setNewTopicValue,
        filterDataQM,setFilterDataQM,
        filterLoaderQM,setFilterLoaderQM,
        fetchFilterDropdownQM,
        deleteQbank,
        deleteQbankLoader,
        wordFileQM, setWordFileQM,
        bulkUploadWordQM,
        qmMonthList, setQmMonthList,
        qmMonthLoader, setQmMonthLoader,
        fetchQMMOnthList
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default QuestionMasterProvider;
